import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mr-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.classObject, "d-flex justify-center items-center border border-transparent text-base leading-6 font-medium rounded-md transition ease-in-out duration-150"])
  }, [
    (_ctx.addCharacterImg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("img", {
            class: "h-16 md:h-20",
            src: "/img/See-Octopus.png"
          }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    (_openBlock(), _createElementBlock("svg", {
      class: _normalizeClass(["animate-spin -ml-1 mr-3 h-5 w-5", _ctx.loadingClassObject]),
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24"
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("circle", {
        class: "opacity-25",
        cx: "12",
        cy: "12",
        r: "10",
        stroke: "currentColor",
        "stroke-width": "4"
      }, null, -1),
      _createElementVNode("path", {
        class: "opacity-75",
        fill: "currentColor",
        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      }, null, -1)
    ]))], 2)),
    _createTextVNode(" " + _toDisplayString(_ctx.loadingText), 1)
  ], 2))
}